import { ITransportationTypeDetailDTO } from 'api/swagger/ApiClient';
import { autoinject, BindingEngine, customElement, newInstance } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ValidationController, ValidationRules } from 'aurelia-validation';
import { BootstrapGroupRenderer } from 'framework/aurelia_tools/bootstrap-group-renderer';
import { cloneDeep } from 'framework/script_utilities/object-equalizer';
import { TransportationTypeModel } from 'model/forms/transportation-type-model';
import { EnumsService } from 'services/enums-service';
import { ModelBase } from 'support/base_classes/model-base';

@autoinject
@customElement('transportation-type-panel')
export class TransportationTypePanelCustomElement extends ModelBase<ITransportationTypeDetailDTO> {
  @bindable controlModel: TransportationTypeModel = null;
  backup: ITransportationTypeDetailDTO = null;

  constructor(bindingEngine: BindingEngine, private enumService: EnumsService, @newInstance() private validationController: ValidationController, validationRenderer: BootstrapGroupRenderer) {
    super(bindingEngine);
    validationRenderer.allowedParents = 'bs-form-input, bs-form-select';
    this.validationController.addRenderer(validationRenderer);
  }

  enumsItemMatcher = this.enumService.itemsMatch;

  bind() {
    this.controlModel.validationController = this.validationController;
    this.model = this.controlModel.data;
    super.bind();
    this.backup = cloneDeep(this.model);
    this.controlModel.rebindData = (dto: ITransportationTypeDetailDTO) => {
      this.controlModel.data = dto;
      this.model = this.controlModel.data;
      this.backup = cloneDeep(this.model);
    };
    this.controlModel.cancelChanges = () => {
      this.controlModel.rebindData(this.backup);
    }
  }

  modelChanged(newValue: ITransportationTypeDetailDTO) {
    super.modelChanged(newValue);
    ValidationRules
      .ensureObject<ITransportationTypeDetailDTO>().required()
      .ensure(model => model.name).displayName('Name').required()
      .ensure(model => model.transportationSystemType).displayName('System Type').required()
      .on(this.model);
    this.validationController.reset();
  }
}
